import { render } from "./OnDemandBookingTelehealth.vue?vue&type=template&id=136fbd54&scoped=true&ts=true"
import script from "./OnDemandBookingTelehealth.vue?vue&type=script&lang=ts"
export * from "./OnDemandBookingTelehealth.vue?vue&type=script&lang=ts"

import "./OnDemandBookingTelehealth.vue?vue&type=style&index=0&id=136fbd54&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136fbd54"]])

export default __exports__